import { Component, Input, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { Pages } from '../../../models/blog.model';
import { TranslateService } from '@ngx-translate/core'
import textTableList from './wht-table-list'
import { Meta, Title } from '@angular/platform-browser'
import { SEOService } from '@flowaccount/landing'
@Component({
  selector: 'flowaccount-tax-calculation',
  templateUrl: './tax-calculation.component.html',
  styleUrls: ['./tax-calculation.component.scss'],
})
export class TaxCalculationComponent implements OnInit {
  @Input() customClassName = 'default'
  @Input() customLink = ''
  myForm: FormGroup
  page = Pages

  private onChangeLangSubscribe

  vatList: any = [
    { name: '0% (ยกเว้น)', value: '0' },
    { name: '1%', value: '1' },
    { name: '2%', value: '2' },
    { name: '3%', value: '3' },
    { name: '5%', value: '5' },
    { name: '7%', value: '7' },
    { name: '10%', value: '10' },
  ]
  private ONE_HUNDRED_PERCENT = 100

  // Invite to Register FlowAccount Header
  customInviteSection = {
    headingDesktopTH: ' มองเห็นกำไรอย่างแม่นยำและต่อเนื่องยิ่งขึ้น<br>บนโปรแกรมบัญชีออนไลน์ FlowAccount ',
    headingDesktopEN: ' มองเห็นกำไรอย่างแม่นยำและต่อเนื่องยิ่งขึ้น<br>บนโปรแกรมบัญชีออนไลน์ FlowAccount ',
    headingMobileTH: ' มองเห็นกำไรอย่างแม่นยำและต่อเนื่องยิ่งขึ้น<br>บนโปรแกรมบัญชีออนไลน์ FlowAccount ',
    headingMobileEN: ' มองเห็นกำไรอย่างแม่นยำและต่อเนื่องยิ่งขึ้น<br>บนโปรแกรมบัญชีออนไลน์ FlowAccount ',
    buttonNameTH: 'ใช้งานฟรีทุกฟังก์ชัน 30 วัน',
    buttonNameEN: 'ใช้งานฟรีทุกฟังก์ชัน 30 วัน',
  }

  // Blog Header
  customHeader = {
    headingTH: 'ภาษี สิ่งสำคัญที่อยู่ในชีวิตประจำวันของเรา ',
    headingEN: 'ภาษี สิ่งสำคัญที่อยู่ในชีวิตประจำวันของเรา ',
    subheadingTH: '',
    subheadingEN: '',
    detailTH:
      'ตัวเลขรายรับ รายได้ และรายจ่ายในชีวิตประจำวันของเราล้วนมีภาษีเป็นส่วนเกี่ยวข้อง มาทำความรู้จักบทบาทของภาษีให้มากขึ้น ในบทความดีๆ ที่เรารวบรวมไว้ให้ ด้านล่างนี้',
    detailEN:
      'ตัวเลขรายรับ รายได้ และรายจ่ายในชีวิตประจำวันของเราล้วนมีภาษีเป็นส่วนเกี่ยวข้อง มาทำความรู้จักบทบาทของภาษีให้มากขึ้น ในบทความดีๆ ที่เรารวบรวมไว้ให้ ด้านล่างนี้',
  }

  percentFromInput = {
    vat: 0,
    wht: 0,
  }
  calculateResultList = {
    originalPrice: 0,
    vatResult: 0,
    whtResult: 0,
    totalValue: 0,
  }
  tableList = textTableList
  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    private titleService: Title,
    private seoService: SEOService,
    private meta: Meta,
  ) {
    // this.setMeta()
    this.onChangeLangSubscribe = this.translate.onLangChange.subscribe((res) => {
      // ใช้ noindex สำหรับหน้า /en เพราะตอนนี้เนื้อหายังมีแค่ภาษาไทย ถ้ามีภาษาอังกฤษเมื่อไหร่ให้ลบออก
      const setContent = res.lang === 'th' ? 'index' : 'noindex'
      this.meta.updateTag({ name: 'robots', content: setContent })
      this.setMeta()
    })
  }
  ngOnInit(): void {
    this.myForm = this.fb.group({
      price: ['', [Validators.required, Validators.min(1)]],
      vat: ['7', [Validators.required, Validators.min(0)]],
      wht: ['3', [Validators.required, Validators.min(0)]],
      priceIncludingVat: ['No', [Validators.required]],
    })
  }
  setMeta() {
    this.titleService.setTitle(this.translate.instant('VAT_WHT_CALCULATION.META_TITLE'))
    this.seoService.createMetaTag(
      this.translate.instant('VAT_WHT_CALCULATION.META_TITLE'),
      this.translate.instant('VAT_WHT_CALCULATION.META_DESCRIPTION'),
    )
    this.seoService.createOg(
      'https://flowaccountcdn.com/new_landing/image/calculation_og_v2.jpg',
      this.translate.instant('VAT_WHT_CALCULATION.META_TITLE'),
      this.translate.instant('VAT_WHT_CALCULATION.META_TITLE'),
    )
  }
  onSubmit(form: FormGroup) {
    let isInCludingVat = form.value.priceIncludingVat === 'Yes' ? true : false

    // ถ้าค่าที่ส่งมาเป็น null or undefined จะ convert เป็น 0, isInCludingVat ถ้าไม่มีค่าจะ default เป็น false
    form.value.price ? form.value.price : (form.value.price = 0)
    form.value.vat ? form.value.vat : (form.value.vat = 0)
    form.value.wht ? form.value.wht : (form.value.wht = 0)
    isInCludingVat ? isInCludingVat : (isInCludingVat = false)

    this.calculatePriceVat(+form.value.price, +form.value.vat, +form.value.wht, isInCludingVat)
    this.percentFromInput.vat = +form.value.vat
    this.percentFromInput.wht = +form.value.wht
  }

  clearValue() {
    this.calculateResultList = {
      originalPrice: 0,
      vatResult: 0,
      whtResult: 0,
      totalValue: 0,
    }
    this.myForm.reset()
  }
  calculatePriceVat(price: number, vat: number, wht: number, isVatInclude: boolean) {
    let total = 0
    let priceBeforeVat = 0
    // ถ้าค่าที่ส่งมาเป็น null or undefined จะ convert เป็น 0,  isVatInclude ถ้าไม่มีค่าจะ default เป็น false
    price ? price : (price = 0)
    vat ? vat : (vat = 0)
    wht ? wht : (wht = 0)
    isVatInclude ? isVatInclude : (isVatInclude = false)

    if (isVatInclude) {
      priceBeforeVat = price * (100 / (100 + vat))
    } else {
      priceBeforeVat = price
    }
    const vatValue: number = priceBeforeVat * (vat / this.ONE_HUNDRED_PERCENT)
    const whtValue: number = priceBeforeVat * (wht / this.ONE_HUNDRED_PERCENT)

    total = priceBeforeVat + vatValue - whtValue

    this.calculateResultList.originalPrice = priceBeforeVat
    this.calculateResultList.vatResult = +vatValue.toFixed(2)
    this.calculateResultList.whtResult = +whtValue.toFixed(2)
    this.calculateResultList.totalValue = +total.toFixed(2)
  }
  selectedVatDropdown(e) {
    this.myForm.get('vat').setValue(e.target.value)
  }
  ngDestroy() {
    this.onChangeLangSubscribe.unsubscribe()
  }
}
